import React from 'react'

const StarIconSvg = (props) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.09194 1.96866C9.44936 1.19379 10.5506 1.19379 10.9081 1.96866L12.5869 5.60843C12.7326 5.92423 13.0319 6.14168 13.3772 6.18262L17.3576 6.65457C18.205 6.75504 18.5454 7.80243 17.9189 8.38179L14.976 11.1032C14.7207 11.3394 14.6064 11.6912 14.6742 12.0323L15.4553 15.9637C15.6216 16.8007 14.7307 17.448 13.9861 17.0312L10.4884 15.0734C10.185 14.9035 9.81503 14.9035 9.51156 15.0734L6.01393 17.0312C5.26932 17.448 4.37836 16.8007 4.54467 15.9637L5.32584 12.0323C5.39362 11.6912 5.2793 11.3394 5.02396 11.1032L2.08114 8.38179C1.45464 7.80242 1.79496 6.75504 2.64235 6.65457L6.62277 6.18262C6.96813 6.14168 7.26742 5.92423 7.41308 5.60843L9.09194 1.96866Z" fill="#FBA754" />
        </svg>


    )
}

export default StarIconSvg